import React from 'react'
import Storage from '../services/Storage';
import MainPrivateRoutes from './MainPrivateRoutes';
import MainPublicRoutes from './MainPublicRoutes';
import { ToastContainer } from 'react-toastify';

const MainRoutes = () => {
    const token = Storage.getTokenDetail() || {};
    return (
        <>
            {!token.accessToken ? <MainPublicRoutes /> : <MainPrivateRoutes />}
            <ToastContainer />
        </>
    )
}

export default MainRoutes
